import React from "react";
import { FaRedo } from "react-icons/fa";
import { GiPodium } from "react-icons/gi";

function StatPill({ label, value }) {
  return (
    <div className="rounded-[1.4rem] border border-white/15 bg-white/10 px-4 py-3 backdrop-blur-xl">
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/55">
        {label}
      </p>
      <p className="mt-1 font-titre text-2xl font-bold text-white">{value}</p>
    </div>
  );
}

function CoachResultsHero({ stats, refreshing, onRefresh }) {
  return (
    <section className="relative z-0 overflow-hidden bg-slate-950 pt-[92px] text-white lg:pt-[108px]">
      <div
        className="absolute inset-0 z-0 bg-cover bg-center opacity-65"
        style={{ backgroundImage: "url('/img/cover/cover_resultat.webp')" }}
      />

      <div className="absolute inset-0 z-0 bg-gradient-to-br from-slate-950 via-slate-950/90 to-orange-950/70" />

      <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 pb-20 pt-10 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-orange-100 backdrop-blur-xl">
              <GiPodium className="text-lg" />
              Espace coach
            </div>

            <h1 className="mt-5 max-w-3xl font-titre text-4xl font-bold tracking-tight sm:text-5xl">
              Résultats des judokas
            </h1>

            <p className="mt-4 max-w-3xl text-sm font-medium leading-7 text-white/65 sm:text-base">
              Saisis rapidement les victoires et défaites depuis ton smartphone,
              puis complète le classement, les observations et les documents de
              compétition.
            </p>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-white/15 bg-white/10 px-5 py-3 text-sm font-bold text-white backdrop-blur-xl transition hover:-translate-y-0.5 hover:bg-white/15 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaRedo className={refreshing ? "animate-spin" : ""} />
            {refreshing ? "Actualisation..." : "Actualiser"}
          </button>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
          <StatPill label="Participations" value={stats.totalResults} />
          <StatPill label="Combats saisis" value={stats.totalFights} />
          <StatPill label="Victoires" value={stats.wins} />
          <StatPill label="Défaites" value={stats.losses} />
          <StatPill label="À compléter" value={stats.withoutResults} />
        </div>
      </div>
    </section>
  );
}

export default CoachResultsHero;
